var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ui-array-text-list"
  }, [_c('div', {
    staticClass: "ui-array-text-list__label"
  }, [_vm.tip ? _c('div', {
    staticClass: "ui-array-text-list__label--tip"
  }, [_c('UiTip', {
    attrs: {
      "message": _vm.tip.message
    }
  })], 1) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + " ")]), _c('div', {
    staticClass: "ui-array-text-list__container"
  }, _vm._l(_vm.modelProxy, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ui-array-text-list__container--item"
    }, [_c('div', {
      staticClass: "ui-array-text-list__container--item__number"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _c('div', {
      staticClass: "ui-array-text-list__container--item__input"
    }, [_c('UiInput', {
      attrs: {
        "type": _vm.inputType,
        "placeholder": _vm.inputPlaceholder,
        "resize": true,
        "maxLength": _vm.maxLength,
        "size": _vm.inputSize,
        "readonly": _vm.readonly,
        "disabled": _vm.disabled,
        "limit-watcher-enabled": false,
        "error": _vm.getFieldError(index),
        "model-value": _vm.getObjVal(index)
      },
      on: {
        "emitValue": function (val) {
          return _vm.setObjVal(index, val);
        },
        "focus": function ($event) {
          return _vm.$emit('focus');
        },
        "blur": function ($event) {
          return _vm.$emit('blur');
        }
      }
    })], 1), _c('div', {
      staticClass: "ui-array-text-list__container--item__actions"
    }, [index + 1 > _vm.minItems && !_vm.isDisabled ? _c('UiButton', {
      attrs: {
        "type": "secondary",
        "prependIcon": "delete-icon"
      },
      on: {
        "click": function ($event) {
          return _vm.remove(index);
        }
      }
    }) : _vm._e()], 1)]);
  }), 0), _vm.showAddAction ? _c('div', {
    staticClass: "ui-array-text-list__actions"
  }, [_c('UiButton', {
    attrs: {
      "label": "Добавить",
      "type": "secondary",
      "prependIcon": "add"
    },
    on: {
      "click": _vm.add
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }